module.exports = __webpack_public_path__ + "static/media/text-viva.629a958c.png";